exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.upload-tip[data-v-ff1a0c50] {\n  color: #f56c6c;\n  font-size: 12px;\n  margin-top: 5px;\n}\n.banner-tabs[data-v-ff1a0c50] {\n  width: 100%;\n}\n.banner-tabs .el-tabs__header[data-v-ff1a0c50] {\n  margin-bottom: 0;\n}\n.banner-tabs .el-tabs__content[data-v-ff1a0c50] {\n  display: none; /* 隐藏内容区域，因为我们只需要tab标签 */\n}", ""]);

// exports
